import { useState, useEffect, useRef } from "react";
import { authFetch } from "../../App";
import { Trash2, Circle } from "lucide-react";
import { API } from "./helpers";

export function InlineTask({ task, contactId, onToggle, onChanged }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(task.titel);
  const inputRef = useRef(null);

  useEffect(() => { if (editing && inputRef.current) inputRef.current.focus(); }, [editing]);

  const save = async () => {
    const trimmed = val.trim();
    if (!trimmed || trimmed === task.titel) { setEditing(false); setVal(task.titel); return; }
    await authFetch(`${API}/crm/contacts/${contactId}/tasks/${task.id}`, {
      method: "PUT", body: JSON.stringify({ titel: trimmed }),
    });
    setEditing(false);
    onChanged();
  };

  const remove = async () => {
    await authFetch(`${API}/crm/contacts/${contactId}/tasks/${task.id}`, { method: "DELETE" });
    onChanged();
  };

  return (
    <div className="flex items-start gap-1 group" data-testid={`task-${task.id}`}>
      <button onClick={onToggle} className="mt-0.5 flex-shrink-0" data-testid={`toggle-task-${task.id}`}>
        <Circle className="w-3 h-3 text-gray-300 hover:text-blue-400" />
      </button>
      <div className="min-w-0 flex-1">
        {editing ? (
          <input
            ref={inputRef}
            value={val}
            onChange={(e) => setVal(e.target.value)}
            onBlur={save}
            onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") { setVal(task.titel); setEditing(false); } }}
            className="text-[11px] text-gray-800 leading-tight w-full bg-blue-50 border border-blue-200 rounded px-1 py-0.5 outline-none"
            data-testid={`inline-edit-task-${task.id}`}
          />
        ) : (
          <p
            className="text-[11px] text-gray-800 leading-tight cursor-text hover:bg-gray-50 rounded px-0.5 -mx-0.5 truncate"
            onDoubleClick={() => setEditing(true)}
            title={task.titel}
            data-testid={`task-title-${task.id}`}
          >
            {task.titel}
          </p>
        )}
        <div className="flex gap-2 text-[10px] text-gray-400 mt-0">
          <span>Offen</span>
          {task.faellig_am && <span>Fällig: {task.faellig_am}</span>}
        </div>
      </div>
      <button onClick={remove} className="text-gray-200 hover:text-red-500 opacity-0 group-hover:opacity-100 mt-0.5 flex-shrink-0" data-testid={`delete-task-${task.id}`}>
        <Trash2 className="w-3 h-3" />
      </button>
    </div>
  );
}
